module.exports = __webpack_public_path__ + "static/img/2.a876e8ce.png";